import { Lock } from "lucide-react";
import { useState } from "react";

export const AdminLoginForm = ({ onLogin }) => {
  const [pin, setPin] = useState('');
  const [pinError, setPinError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPinError('');
    const error = await onLogin(pin);
    if (error) setPinError(error);
  };

  return (
    <main className="pt-28 md:pt-36 min-h-screen bg-gray-50" data-testid="admin-login-page">
      <div className="max-w-md mx-auto px-4 py-20">
        <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-celebration-red/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Lock className="w-8 h-8 text-celebration-red" />
            </div>
            <h1 className="font-serif text-3xl mb-2">Admin Access</h1>
            <p className="text-gray-500">Enter your PIN to view orders</p>
          </div>
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              placeholder="Enter Admin PIN"
              className="w-full p-4 border rounded-lg bg-gray-50 text-center text-2xl tracking-widest mb-4"
              data-testid="admin-pin-input"
              autoFocus
            />
            {pinError && <p className="text-red-500 text-sm text-center mb-4" data-testid="admin-pin-error">{pinError}</p>}
            <button type="submit" className="w-full btn-primary" data-testid="admin-login-button">
              Access Dashboard
            </button>
          </form>
        </div>
      </div>
    </main>
  );
};
